import * as Types from '../constants/actionTypes';
const defaultState = {
    assetsData: {},
    inventoryData: {},
    requestData: {},
    settlementData: {},
    storyboardError: '',
    storyboardProgBar: []
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.PORTAL_STORYBOARD_ASSETS:
            return {
                ...state,
                assetsData: action.data,
                storyboardError: ''
            }
        case Types.PORTAL_STORYBOARD_INVENTORY_REPORT:
            return {
                ...state,
                inventoryData: action.data,
                storyboardError: ''
            }
        case Types.PORTAL_STORYBOARD_REQUEST_SUMMARY:
            return {
                ...state,
                requestData: action.data,
                storyboardError: ''
            }
        case Types.PORTAL_STORYBOARD_SETTLEMENT_SUMMARY:
            return {
                ...state,
                settlementData: action.data,
                storyboardError: ''
            }
        case Types.PORTAL_STORYBOARD_PROG_BAR:
            return {
                ...state,
                storyboardProgBar: action.data
            }
        case Types.PORTAL_STORYBOARD_FETCH_ERROR:
            return {
                ...state,
                storyboardError: action.message
            }
        default:
            return state
    }
}
